/* eslint max-len : [off] */
import React from 'react';
import { Button, DropdownButton, MenuItem } from 'react-bootstrap';
import classNames from 'classnames';
import { isUndefined } from 'lodash';
import { Image } from '@components/common';
import utils, { constants } from '@utils';

const paymentColumns = (viewType, selectAll, onCheckBoxChange, selectAllChanged, actionClicked, payNowClicked, totalLength, CheckBox, PhotoFormatter) => {
	const columns = [
		{
			property : 'checked',
			header   : {
				formatters : [
					() => (
						<label htmlFor="select-all" className="big-checkbox header">
							<input
								disabled={!totalLength}
								type="checkbox"
								name="select-all"
								id="select-all"
								data-clickable
								checked={selectAll[viewType] || false}
								onChange={selectAllChanged(!selectAll[viewType])}
							/>
							<span data-clickable className="clickable checkmark" />
						</label>
					),
				],
			},
			cell : {
				props : {
					className : 'padding-0',
				},
				formatters :
					[
						(value, { rowIndex, rowData }) => (
							<CheckBox
								rowIndex={rowIndex}
								statusId={rowData.statusId}
								value={value}
								onCheckBoxChange={onCheckBoxChange}
							/>
						),
					],
			},
		},
		{
			property : 'location',
			header   : {
				label : 'Location',
			},
			cell : {
				formatters : [
					(value, { rowData }) => (
						<p className="margin-bottom-0 margin-left--10 mobile-max-width">
							<i className="rkfm rkfm-location color-gray-mine-shaft font-size-15 pull-left margin-top-5 margin-right-5" />
							<If condition={value}>
								<span className="font-regular display-box color-gray-mine-shaft font-size-15">{ value.StreetAddress || ''}</span>
								<If condition={value.StreetAddress2}>
									<span className="font-regular display-box color-gray-mine-shaft font-size-15">
										{value.StreetAddress ? ', ' : ''}
										{value.StreetAddress2}
									</span>
								</If>
								<br />
								<span className="font-regular display-box margin-left-20 color-gray-mine-shaft font-size-15">
									{value.City || ''}
									{value.City && (value.StateName || value.ZipCode) ? ', ' : ''}
									{value.StateName || ''}
									{value.StateName && value.ZipCode ? ' ' : ''}
									{value.ZipCode || ''}
								</span>
							</If>
							<span className="font-regular font-size-14 display-block margin-left-20 color-gray-bayoux">
								{`#${rowData.jobId}`}
							</span>
						</p>
					),
				],
			},
		},
		{
			property : 'officername',
			header   : {
				label : 'Officers',
			},
			cell : {
				formatters : [(value) => <PhotoFormatter value={value} />],
			},
		},
		{
			property : 'startdatetime',
			header   : {
				label : 'Job Date',
			},
			cell : {
				formatters : [
					(value) => (
						<p className="margin-bottom-0">
							<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value ? value.date : '' }</span>
							<span className="font-regular display-block color-gray-bayoux font-size-14">
								{ value ? value.startTime : '' }
								{' '}
								-
								{' '}
								{ value ? value.endTime : '' }
							</span>
						</p>
					),
				],
			},
		},
		{
			property : 'invoicedamount',
			header   : {
				label : 'Invoiced Amount',
				props : { className : 'invoice-amt-column text-right' },
			},
			cell : {
				formatters : [
					(value, { rowData : { isPrepaid } }) => (
						<p className="margin-bottom-0 text-right">
							{isPrepaid === true && (
								<span
									className="display-inline-block tag tag-success"
									title="This job has been prepaid, no overtime hours are allowed."
								>
									Prepaid
								</span>
							)}
							<span className="font-regular display-inline-block color-gray-mine-shaft font-size-15">{ utils.currencyFormatter(value ? value.amount : 0) }</span>
							<span className="font-regular display-block color-gray-bayoux font-size-14">
								(
								{ parseFloat(value ? value.invoicedHours : 0).toFixed(2) }
								{' '}
								hours)
							</span>
						</p>
					),
				],
			},
		},
		{
			property : 'actions',
			cell     : {
				formatters : [
					(value, {
						rowData : {
							checked, rowId, statusId, showPaymentButton, isPrepaid,
						},
					}) => (
						<div className="padding-top-10 text-center">
							<If
								condition={
									statusId === constants.INVOICE_STATUSES.PENDING_PAYMENT
									|| statusId === constants.INVOICE_STATUSES.PENDING_PROCESSING
								}
							>
								<Choose>
									<When condition={statusId === constants.INVOICE_STATUSES.PENDING_PROCESSING}>
										<Button
											data-clickable
											disabled
											bsSize="small"
											bsStyle="warning"
											className="btn btn-primary margin-right-10"
										>
											Payment Processing
										</Button>
									</When>
									<Otherwise>
										<If condition={showPaymentButton}>
											<Button
												data-clickable
												disabled={checked}
												bsSize="small"
												className="btn btn-primary margin-right-10"
												onClick={payNowClicked('individual', rowId)}
											>
												Pay Now
											</Button>
										</If>
									</Otherwise>
								</Choose>
							</If>
							<If
								condition={
									statusId === constants.INVOICE_STATUSES.PENDING_REVIEW
									|| statusId === constants.INVOICE_STATUSES.PENDING_CLIENT_REVIEW
									|| statusId === constants.INVOICE_STATUSES.AMENDED
								}
							>
								<DropdownButton
									data-clickable
									disabled={checked}
									bsSize="small"
									title="Actions"
									className="btn btn-primary margin-right-10"
									id="approve-invoice-button"
								>
									<MenuItem
										data-clickable
										eventKey="1"
										onClick={actionClicked('individual', rowId, isPrepaid)}
									>
										Approve Invoice
									</MenuItem>
									<MenuItem
										data-clickable
										eventKey="2"
										onClick={actionClicked('dispute', rowId)}
									>
										Dispute Invoice
									</MenuItem>
								</DropdownButton>
							</If>
						</div>
					),
				],
			},
		},
	];

	const receivedColumn = {
		property : 'SentDateTimeUTC',
		header   : {
			label    : 'Received',
			sortable : true,
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<p className="margin-bottom-0">
						<span className="font-regular display-block color-gray-mine-shaft font-size-15">
							{rowData.SentDateTimeUTC === 'Invalid date' ? '' : rowData.SentDateTimeUTC}
						</span>
					</p>
				),
			],
		},
	};

	if (viewType === 'review' || viewType === 'payment') {
		columns.splice(-2, 0, receivedColumn);
	}
	return columns;
};
const disputeColumns = [
	{
		property : 'invoiceNo',
		header   : {
			label : 'Invoice #',
		},
		cell : {
			formatters : [
				(value) => (
					<span className="font-regular font-size-16 text-primary">{ value }</span>
				),
			],
		},
	},
	{
		property : 'invoicedamount',
		header   : {
			label : 'Invoiced On',
		},
		cell : {
			formatters : [
				(value) => (
					<p className="margin-bottom-0">
						<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value.date }</span>
						<span className="font-regular display-block color-gray-bayoux font-size-14">{ value.time }</span>
					</p>
				),
			],
		},
	},
	{
		property : 'invoicedamount',
		header   : {
			label : 'Disputed On',
		},
		cell : {
			formatters : [
				(value) => (
					<p className="margin-bottom-0">
						<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value.date }</span>
						<span className="font-regular display-block color-gray-bayoux font-size-14">{ value.time }</span>
					</p>
				),
			],
		},
	},
	{
		property : 'disputeReason',
		header   : {
			label : 'Reason',
		},
		cell : {
			formatters : [
				(value) => (
					<p className="margin-bottom-0">
						<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value }</span>
					</p>
				),
			],
		},
	},
	{
		property : 'officername',
		header   : {
			label : 'Officers',
		},
		cell : {
			formatters : [
				(value) => (
					<div className="flex mobile-max-width">
						<Image
							className="height-50 width-50 border-radius-rounded margin-right-10 img-cover"
							src={value.photo || ''}
							fallbackSrc="avatar"
						/>
						<p className="margin-bottom-0">
							<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value.name }</span>
							<span className="font-regular display-block color-gray-bayoux font-size-14">{ value.rank }</span>
						</p>
					</div>
				),
			],
		},
	},
];

const invoiceBreakDownColumn = [
	{
		property : 'description',
		header   : {
			label : 'Description',
		},
		cell : {
			formatters : [
				(value, {
					rowData : {
						description, name, image, firstCoordinator,
					},
				}) => (
					<Choose>
						<When condition={isUndefined(image)}>
							<span className="font-regular font-size-12 color-gray-cloud-burst display-block">{ description }</span>
						</When>
						<Otherwise>
							<If condition={firstCoordinator}>
								<span className="font-bold color-dark display-block padding-bottom-5 font-size-12">Coordinators</span>
							</If>
							<div className="flex">
								<Image
									className="height-20 width-20 border-radius-10 margin-right-10 img-cover"
									src={image || ''}
								/>
								<p className="margin-bottom-0">
									<span className="font-regular font-size-12 color-gray-cloud-burst display-block">{ name }</span>
								</p>
							</div>
						</Otherwise>
					</Choose>
				),
			],
		},
	},
	{
		property : 'rate',
		header   : {
			label : 'Rate',
		},
		cell : {
			formatters : [
				(value, { rowData : { rate } }) => (
					<If condition={!isUndefined(rate)}>
						<span className="font-regular font-size-12 color-gray-cloud-burst display-block">
							{utils.currencyFormatter(rate)}
							/hr
						</span>
					</If>
				),
			],
		},
	},
	{
		property : 'quantity',
		header   : {
			label : 'Quantity',
		},
		cell : {
			formatters : [
				(value, {
					rowData : {
						quantity, type, label, clockIn, clockOut,
					},
				}) => (
					<Choose>
						<When condition={type === 'total'}>
							<span className="font-bold font-size-12 color-dark display-block">{ label }</span>
						</When>
						<Otherwise>
							<span className="font-regular font-size-12 color-gray-cloud-burst display-block">{ quantity }</span>
							<If condition={clockIn && clockOut}>
								<span className="font-regular font-size-10 color-gray-cloud-burst display-block">
									{ clockIn }
									{' '}
									-
									{' '}
									{ clockOut }
								</span>
							</If>
						</Otherwise>
					</Choose>
				),
			],
		},
	},
	{
		property : 'total',
		header   : {
			label : 'Total',
		},
		cell : {
			formatters : [
				(value, {
					rowData : {
						total, type, label, firstCoordinator,
					},
				}) => (
					<span
						className={classNames('font-size-12', {
							'font-regular color-gray-cloud-burst' : isUndefined(type),
							'font-bold color-dark'                : !isUndefined(type),
							'font-size-14 font-bold text-primary' : label === 'TOTAL',
							'padding-top-5'                       : firstCoordinator,
						})}
					>
						{ utils.currencyFormatter(total || 0) }
					</span>
				),
			],
		},
	},
];

const paymentReceiptColumn = (onClickInvoiceId) => ([
	{
		property : 'invoice',
		header   : {
			label : 'Invoice #',
		},
		cell : {
			formatters : [
				(value) => (
					<If condition={value}>
						<span
							onClick={() => onClickInvoiceId(value)}
							className="font-regular font-size-16 text-primary cursor-pointer"
							role="link"
							tabIndex={0}
							onKeyPress={undefined}
						>
							{value ? value.id : ''}
						</span>
					</If>
				),
			],
		},
	},
	{
		property : 'dateTime',
		header   : {
			label : 'Date/Time',
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<If condition={isUndefined(rowData.type)}>
						<p className="margin-bottom-0">
							<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value.date }</span>
							<span className="font-regular display-block color-gray-bayoux receipt-table-sub-text">
								{ value.startTime }
								{' '}
								-
								{' '}
								{ value.endTime }
							</span>
						</p>
					</If>
				),
			],
		},
	},
	{
		property : 'location',
		header   : {
			label : 'Location',
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<If condition={isUndefined(rowData.type)}>
						<p className="margin-bottom-0 mobile-max-width">
							<span className="font-regular display-box color-gray-mine-shaft font-size-15">{ value }</span>
						</p>
					</If>
				),
			],
		},
	},
	{
		property : 'officername',
		header   : {
			label : 'Officers',
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<Choose>
						<When condition={rowData.type === 'total' || rowData.type === 'additional'}>
							<span className={classNames('color-dark display-block font-size-16', { 'font-bold ' : rowData.type === 'total' })}>{rowData.label}</span>
						</When>
						<Otherwise>
							<If condition={rowData.firstCoordinator}>
								<span className="font-bold color-dark display-block padding-bottom-5 font-size-16">Coordinator</span>
							</If>
							<div className="flex flex-align-items-center mobile-max-width">
								<Image
									className="height-30 width-30 border-radius-15 margin-right-10 img-cover"
									src={value.image || ''}
									fallbackSrc="avatar"
								/>
								<p className="margin-bottom-0">
									<span className="font-regular display-block color-gray-mine-shaft font-size-15">{ value.name }</span>
								</p>
							</div>
						</Otherwise>
					</Choose>
				),
			],
		},
	},
	{
		property : 'hours',
		header   : {
			label : 'Hours',
			props : { className : 'text-right' },
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<div className={classNames('color-gray-mine-shaft font-size-15 text-right', { 'font-regular' : rowData.type !== 'total', 'font-bold font-size-16' : rowData.type === 'total', 'padding-top-20' : rowData.firstCoordinator })}>{value}</div>
				),
			],
		},
	},
	{
		property : 'rate',
		header   : {
			label : 'Rate',
			props : { className : 'text-right' },
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<If condition={rowData.rate}>
						<div className={classNames('font-regular color-gray-mine-shaft font-size-15 text-right', { 'padding-top-20' : rowData.firstCoordinator })}>
							{utils.currencyFormatter(value)}
							/hr
						</div>
					</If>
				),
			],
		},
	},
	{
		property : 'amountDue',
		header   : {
			label : 'Amount',
			props : { className : 'text-right' },
		},
		cell : {
			formatters : [
				(value, { rowData }) => (
					<Choose>
						<When condition={rowData.label !== 'TOTAL'}>
							<div className={classNames('text-right', { 'font-regular font-size-15' : rowData.type !== 'total', 'font-bold font-size-16' : rowData.type === 'total', 'padding-top-20' : rowData.firstCoordinator })}>{utils.currencyFormatter(value || 0)}</div>
						</When>
						<Otherwise>
							<div className="font-bold font-size-24 text-right">{utils.currencyFormatter(value)}</div>
						</Otherwise>
					</Choose>
				),
			],
		},
	},
]);

export {
	paymentColumns,
	disputeColumns,
	invoiceBreakDownColumn,
	paymentReceiptColumn,
};
